import React,{useEffect, useState} from "react";

const FreeToolsLayout = ({ mainHeading, subHeading, children }) => {
  const [subdomain, setSubdomain] = useState(null);

  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length > 2) {
      setSubdomain(parts[0]);
    }
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-6">
      <div className="text-center mb-[40px]">
        <h1 className={`text-[34px] leading-[29px] font-semibold mb-[15px] ${subdomain === 'resources'  ? "text-white": ""}`}>{mainHeading}</h1>
        <p className="text-[#a7a7a7] text-[17px]">{subHeading}</p>
      </div>
      <div className="flex gap-5 flex-col bg-[linear-gradient(268deg,_#ebe7ff,_#faf4f7_51%,_#f4e7f3)] rounded-[30px] p-5 relative">{children}</div>
    </div>
  );
};

export default FreeToolsLayout;
